import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { paths } from 'configuration/paths';
import { useAuthentication } from 'hooks/useAuthentication';

interface IProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: IProps) => {
  const { user, loading } = useAuthentication();
  const { loggedIn } = user || {};
  const location = useLocation();

  if (loading) {
    // the delay here is very small (basically just retrieving existing login state from IndexedDB)
    // so it's okay just to show an empty page for a split second
    return null;
  }

  return loggedIn ? children : <Navigate to={{ pathname: paths.login }} state={location.pathname} />;
};
